import Vue from 'vue'
import { axios } from '@/utils/request'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export function getImgList(parameter) {
  return axios({
    url: '/distribution/basicProduct',
    method: 'GET',
    params: parameter
  })
}

export function getSingleImgInfo(id) {
  const token = Vue.ls.get(ACCESS_TOKEN)
  return axios({
    url: token ? `/distribution/basicProduct/${id}` : `/frontend/basicProduct/${id}`,
    method: 'GET'
  })
}

export function getDesignImgList(parameter) {
  return axios({
    url: '/distribution/material',
    method: 'GET',
    params: parameter
  })
}

export function saveDesign(data) {
  return axios({
    url: '/distribution/product',
    method: 'POST',
    data
  })
}
// 获取和颜色尺码匹配的价格
export function getPurchasePrice(data) {
  return axios({
    url: '/distribution/basicProduct/getPurchaseRule/' + data.id,
    method: 'GET',
    params: data.data
  })
}
// 改变图片风格
export function changeImgStyle(data) {
  return axios({
    url: '/distribution/materialStyle',
    method: 'POST',
    data: data
  })
}

// 获取风格种类
export function getImgStyleNum() {
  return axios({
    url: '/api/systemConfig/designStyle',
    method: 'GET'
  })
}

// 获取遮罩图层
export function getMaskLayer() {
  return axios({
    url: '/api/systemConfig/designMask',
    method: 'GET'
  })
}

// 获取用户我的分类
export function getUserCategory() {
  return axios({
    url: '/distribution/userBasicProductCategory',
    method: 'GET'
  })
}

// 处理素材
export function handleMaterialVision(data) {
  return axios({
    url: '/distribution/materialVision',
    method: 'POST',
    data
  })
}
// 获取用户自定义快捷键
export function getUserHotKeys() {
  return axios({
    url: '/distribution/userConfig/userHotKeys',
    method: 'GET'
  })
}
// 修改用户自定义快捷键
export function setUserHotKeys(data) {
  return axios({
    url: '/distribution/userConfig/setUserHotKeys',
    method: 'POST',
    data
  })
}
// 归类
export function getCategoryImgList(parameter) {
  return axios({
    url: '/distribution/basicProduct/categoryBasicProducts',
    method: 'GET',
    params: parameter
  })
}
// 获取自定义颜色
export function getUserColors(parameter) {
  return axios({
    url: '/distribution/userConfig/userColors',
    method: 'GET',
    params: parameter
  })
}
// 添加自定义颜色
export function addUserColors(data) {
  return axios({
    url: '/distribution/userConfig/userColors',
    method: 'PUT',
    params: data
  })
}
// 删除自定义颜色
export function deleteUserColors(data) {
  return axios({
    url: '/distribution/userConfig/deleteUserColors',
    method: 'POST',
    params: data
  })
}
// 获取动漫风格列表
export function getMaterialVision() {
  return axios({
    url: '/frontend/materialVision/designStyle',
    method: 'GET'
  })
}

// 获取ossinfo
export function getOssInfo() {
  return axios({
    url: '/admin/ossUpload?type=3',
    method: 'GET'
  })
}

// 上传图片
export function uploadImg(data) {
  return axios({
    url: 'https://printus.oss-us-west-1.aliyuncs.com',
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data
  })
}

// 添加素材
export function addMaterial(data) {
  return axios({
    url: '/distribution/material',
    method: 'POST',
    data
  })
}
// 查看pod模板详情
export function getPodTemplate(id) {
  return axios({
    url: '/distribution/podTemplate/' + id,
    method: 'GET'
  })
}
